import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects/feedback-email', 'put'>;
type ResponseBody = OASOutput<O, '/api/projects/feedback-email', 'put'>;

type Params = {
  projectId: number;
  courseFeedbackEmailAddress: string;
};

type Result = {
  id: number;
};

export const updateProjectFeedbackEmailFactory = (apiClient: ApiClient) => {
  const updateProjectFeedbackEmail = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/projects/feedback-email'].put(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        projectId: input.projectId,
        courseFeedbackEmailAddress: input.courseFeedbackEmailAddress,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
    };
  };

  return updateProjectFeedbackEmail;
};
